import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import { formatBytes } from 'ca-js-helper';
export const maxFilesize = ca.config('media.download.multiple.max_size');

const download = {
    data() {
        return {
            selectedItems: [],
        };
    },
    computed: {
        ...mapGetters('app', ['getDownloadManyUrl']),
        totalFileSize() {
            return this.selectedItems.map((i) => i.size).reduce((sum, current) => sum + current, 0);
        },
        isMaxFilesize() {
            return this.totalFileSize >= maxFilesize;
        },
        selectedIds() {
            return this.selectedItems.map((i) => i.item.id);
        },
        selectedCount() {
            return this.selectedItems.length;
        },
        downloadAllURL() {
            const url = new URL(this.item.url.short_link);
            const guestID = Cookies.get('app_guest_id', { path: `/s/${this.item.id}` });
            const guestEmail = Cookies.get('app_guest_email', { path: `/s/${this.item.id}` });

            if (guestID) url.searchParams.append('guest_id', guestID);
            if (guestEmail && guestEmail !== 'undefined') url.searchParams.append('guest_email', guestEmail);

            return url;
        },
    },
    methods: {
        async doDownload(item) {
            const url = new URL(item.url);
            const link = document.createElement('a');

            const guestID = Cookies.get('app_guest_id', { path: `/s/${this.item.id}` });
            const guestEmail = Cookies.get('app_guest_email', { path: `/s/${this.item.id}` });

            if (!item.isMediaSet) {
                if (guestID) url.searchParams.append('guest_id', guestID);
                if (guestEmail && guestEmail !== 'undefined') url.searchParams.append('guest_email', guestEmail);
            }

            if (item.isImage) {
                url.searchParams.append('p', 'download-original');
                link.href = url.href;
            } else if (item.isMediaSet) {
                const base64Items = btoa(JSON.stringify({ media: [item.id] }));
                link.href = this.getDownloadManyUrl(base64Items, { id: item.id });
                const filesize = item.mediaTotalFilesize;
                if (filesize >= maxFilesize) {
                    this.showMaxFilesizeError();
                    return;
                }
            } else {
                url.searchParams.append('p', 'download');
                link.href = url.href;
            }

            link.click();
        },
        doDownloadSelected(itemId = null) {
            if (this.selectedCount > 0 && !this.isMaxFilesize) {
                if (this.selectedCount === 1) {
                    const first = this.selectedItems.pop();
                    const item = first.item;
                    if (item) {
                        return this.doDownload(item);
                    }
                }
                const mediaIds = { media: this.selectedIds };
                const base64Items = btoa(JSON.stringify(mediaIds));
                const downloadText = `Begin download <small>(${formatBytes(this.totalFileSize)})</small>`;
                ca.confirm({
                    type: 'download',
                    html: `<p>Click the button below to begin your download.<p><a class="btn btn-primary btn-lg center-block" onclick="Swal.closeModal();" href="${this.getDownloadManyUrl(
                        base64Items,
                        { id: itemId }
                    )}">${downloadText}</a>`,
                });
            } else if (isMaxFilesize) {
                this.showMaxFilesizeError();
            }
        },
        getItemFilesize(item) {
            let size = 0;
            if (!item.isMediaSet) {
                if (item.hasOriginalSize) {
                    size = item.original.size;
                } else if (item.hasSize) {
                    size = item.file.size;
                }
            } else {
                size = item.mediaTotalFilesize;
            }
            return size;
        },
        showMaxFilesizeError() {
            ca.notify({
                type: 'error',
                icon: 'bomb',
                message: `The selected items exceed the maximum allowed filesize of: ${formatBytes(maxFilesize)}`,
                timeout: ca.config('toast.timeout'),
            });
        },
        doClearSelected() {
            this.selectedItems = [];
        },
    },
};

export default download;
